import { toast } from 'react-toastify';
import api from '@/shared/api';
import { API_ERRORS, ENDPOINTS } from '@/shared/constants';
import { ApiError } from '@/models/apiError';

export interface WhatsappStatusResponse {
  connected: boolean
  error?: string
  smartphoneConnected?: boolean
}

export default function useWhatsappApi() {
  async function getStatusDetails(): Promise<WhatsappStatusResponse | number> {
    try {
      const res = await api.get(ENDPOINTS.WHATSAPP.GET.STATUS);
      return res.data;
    } catch (error) {
      const apiError = error as ApiError;
      const errorCode = apiError.response?.data?.errorCode;
      handleError(errorCode);
      if (errorCode) {
        return errorCode
      }
      return {
        connected: false,
      };
    }
  }

  async function getStatus(): Promise<boolean | number> {
    const status = await getStatusDetails()

    return typeof status === 'number' ? status : status.connected
  }

  async function getQrCode() {
    try {
      const res = await api.get(ENDPOINTS.WHATSAPP.GET.QR_CODE);
      return res.data;
    } catch (error) {
      const apiError = error as ApiError;
      handleError(apiError.response?.data?.errorCode);
      return false;
    }
  }

  function handleError(errorCode?: number) {
    if (errorCode && API_ERRORS[errorCode]) {
      toast.error(API_ERRORS[errorCode]);
    } else {
      toast.error('Erro de configuração do WhatsApp, contate o suporte');
    }
  }

  return { getStatus, getStatusDetails, getQrCode };
}
